import { SubmitZoneConnectionRate } from "@/types/zone-connection-rates-type"

import { apiFetch } from "../utils"
import { postActivityLog } from "./log"

const billingUrl = `himo-billing/`

export async function getZoneConnectionRate() {
  const response = await apiFetch(`${billingUrl}zone-connection-rate/?size=25`)

  if (!response.ok) {
    throw new Error(`Cannot fetch zone connection rate`)
  }

  return (await response).json()
}
export async function getZoneConnectionRateById(id: number) {
  const response = await apiFetch(`${billingUrl}zone-connection-rate/${id}`)

  if (!response.ok) {
    throw new Error(`Cannot fetch zone connection rate by id`)
  }

  return await response.json()
}

export async function addZoneConnectionRate(data: SubmitZoneConnectionRate) {
  const response = await apiFetch(`${billingUrl}zone-connection-rate/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/zone-connection-rates",
      action: `Add Zone Connection Rate (${data.zone_id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Cannot add zone connection rate`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Zone Settings",
    sub_menu_path: "/zone-settings/zone-connection-rates",
    action: `Add Zone Connection Rate (${data.zone_id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return await response.json()
}

export async function editZoneConnectionRate(
  data: SubmitZoneConnectionRate,
  id: number,
) {
  const response = await apiFetch(`${billingUrl}zone-connection-rate/${id}/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/zone-connection-rates",
      action: `Edit Zone Connection Rate (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Cannot edit zone connection rate`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Zone Settings",
    sub_menu_path: "/zone-settings/zone-connection-rates",
    action: `Edit Zone Connection Rate (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return await response.json()
}

export async function deleteZoneConnectionRate(id: number) {
  const response = await apiFetch(`${billingUrl}zone-connection-rate/${id}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/zone-connection-rates",
      action: `Delete Zone Connection Rate (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Cannot fetch zone connection rate`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Zone Settings",
    sub_menu_path: "/zone-settings/zone-connection-rates",
    action: `Delete Zone Connection Rate (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return await response.json()
}

